"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transform = void 0;
/** Convert all object values to strings */
const toStrings = (data) => {
    const result = {};
    Object.entries(data).forEach(([key, value]) => {
        result[key] = String(value);
    });
    return result;
};
/** Flatten data with dot notation */
const flatten = (data, parentKey) => {
    let result = {};
    Object.entries(data).forEach(([key, value]) => {
        const newKey = parentKey ? parentKey + "." + key : key;
        // objects and arrays are both "object", recursively flatten
        if (typeof value === "object" && value !== null) {
            result = Object.assign(Object.assign({}, result), flatten(value, newKey));
        }
        // store the flat value
        else {
            result[newKey] = value;
        }
    });
    return result;
};
/** Expand dot notation keys into nested data */
const unflatten = (data) => {
    const result = {};
    Object.entries(data).forEach(([key, value]) => {
        // scans through result object to set data at specific locations
        let window = result;
        const keyParts = key.split(".");
        keyParts.forEach((keyPart, index) => {
            // haven't seen this part yet
            if (window[keyPart] === undefined) {
                // next part isn't a number, initialize as object
                if (Number.isNaN(Number(keyParts[index + 1]))) {
                    window[keyPart] = {};
                }
                // next part is a number, initialize as array
                else {
                    window[keyPart] = [];
                }
            }
            // last index, set the value here
            if (index === keyParts.length - 1) {
                window[keyPart] = value;
            }
            // switch to the sub key
            else {
                window = window[keyPart];
            }
        });
    });
    return result;
};
/** Helper methods for working with nested data and field values */
exports.Transform = {
    toStrings,
    flatten,
    unflatten,
    // wrapped
    /** Flattens all values and converts to strings */
    toFieldValues: (data) => toStrings(flatten(data)),
    /** Converts flat data back to nested data */
    toNestedData: (data) => unflatten(data),
};
